import React from 'react';
import i18n from 'i18n-js';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        tag: {
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.common.white,
            borderRadius: 4,
            padding: '2px 6px',
            fontSize: 11,
            fontWeight: 700,
            lineHeight: '16px',
        },
    })
);

export default function PreOrderTag() {
    const classes = useStyles();
    return <span className={classes.tag}>{i18n.t('orders.preOrder')}</span>;
}
